"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformAPIEvent = exports.transformClubEvent = void 0;

var humps_1 = __importDefault(require("humps"));

function transformClubEvent(event) {
  var renamedKeys = humps_1.default.camelizeKeys(event);
  renamedKeys.start = new Date(event.start);
  renamedKeys.end = new Date(event.end);

  if (renamedKeys.presenter.image) {
    renamedKeys.presenter.image = Buffer.from(renamedKeys.presenter.image);
  }

  return renamedKeys;
}

exports.transformClubEvent = transformClubEvent;

function transformAPIEvent(event) {
  var renamedKeys = humps_1.default.camelizeKeys(event);
  renamedKeys.dateTime = new Date(event.date_time);
  renamedKeys.endDateTime = new Date(event.end_date_time);
  return renamedKeys;
}

exports.transformAPIEvent = transformAPIEvent;